export function allHotelProductsSchema(hotelId: number, pinnedResult: boolean) {
  return [
    {
      messageContent: {
        numOfProducts: 1,
        hotelProducts: [
          {
            pinned: {
              pinnedResult
            },
            productType: 'HOTELS',
            productId: hotelId
          }
        ]
      },
      schemaName: 'allHotelProducts'
    }
  ];
}

export function allRoomsSchema(category: string, offerType: string, promotionId: number, hotelId: number) {
  return [
    {
      messageContent: {
        numOfProducts: 1,
        hotelProducts: [
          {
            productId: hotelId
          }
        ],
        rooms: [
          {
            ratePlans: [
              {
                valueAddPromotions: [
                  {
                    category,
                    offerType,
                    promotionId
                  }
                ]
              }
            ]
          }
        ]
      },
      schemaName: 'allRooms'
    }
  ];
}
